<template src="./template.html" />
<script>
/* eslint-disable */
import EventBus from '@/EventBus'
import { firebase } from '@firebase/app'
const { DocumentReference } = firebase.firestore
export default {
  name: 'DetailPage',
  props: {
    'title': {
      type: String,
      default: ''
    },
    'canSubmit': {
      type: Boolean,
      default: true
    },
    'backConfirm': {
      type: Boolean,
      default: true
    },
    'backLink': {
      type: [Object, String],
      default: '/'
    },
    'scaffolding': {
      type: Object,
      default: () => {}
    },
    'queryPath': {
      type: Array,
      default: () => []
    },
    'mode': {
      type: String,
      default: undefined
    },
    'baseData': {
      type: Object,
      default: () => {}
    },
    'fetchAfterSubmit': {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataPath: null,
      data: this.baseData ? this.baseData : {},
      originData: this.baseData ? this._.cloneDeep(this.baseData) : {},
      isLoading: true,
      isSubmiting: false,
      privateMode: this.mode,
      privateID: this.queryPath[1],
      confirm: false,
      formKey: 1,
      confirmLeave: false
    }
  },
  created () {
   
    this.privateMode = !this.mode ? (this.privateID ? 'EDIT' : 'CREATE') : this.mode
    this.dataPath = this.queryPath.join('/')
  },
  async mounted () {
    this.showLoading()
    if (!this.baseData && (this.privateMode === 'EDIT' || this.privateID)) {
      await this.fetchData(this.queryPath)
    }
    this.$emit('detail-page-fetched', this.data)
    this.isLoading = false
    this.hideLoading()
  },
  methods: {
    removeEmpty(obj) {
      let vm = this
      let cloneObj = vm._.cloneDeep(obj)
      Object.entries(cloneObj).forEach(([key, val]) => {
        if (val && typeof val === 'object' && !Array.isArray(val) && !(val instanceof DocumentReference)) {
          vm.removeEmpty(val)
        } else if (vm._.isNil(val) || (!vm._.isNumber(val) && vm._.isEmpty(val)) || val instanceof DocumentReference) {
          if(key === 'subTask') {
            console.log(vm._.isEmpty(val))
          }
          delete cloneObj[key]
        }
      })
      return cloneObj
    },
    onBackButtonClick() {
      if(this.backConfirm && !this._.isEqual(this.removeEmpty(this.data), this.removeEmpty(this.originData))) {
        this.confirmLeave = true
      } else {
        this.pushBack()
      }
    },
    pushBack() {
      this.$router.push(this.backLink)
    },
    async fetchData (queryPath) {
      await this.$query(queryPath).then(res => {
        this.data = res
        this.originData = this._.cloneDeep(this.data)
      }).catch(error => {
        this.$q.notify({
          message: `${error}`,
          color: 'red',
          icon: 'error'
        })
      })
    },
    async submitData () {
      let vm = this
      vm.$refs.form.validate().then(async canSubmit => {
        if (canSubmit) {
          if(vm.confirmLeave) {
            await this.beginSubmit()
            this.pushBack()
          } else {
            vm.confirm = true
          }
        }
      })
    },
    async beginSubmit () {
      let vm = this
      vm.isSubmiting = true
      try {
        let result = new Promise((resolve, reject) => vm.$emit('submit-event', { data: vm.data, id: vm.privateID }, resolve, reject))
        await result.then(async (res) => {
          vm.privateID = vm.privateMode === 'CREATE' || vm.privateMode === 'COPY' ? res.data.id : vm.privateID
          vm.queryPath[1] = vm.privateID
          vm.$router.push(vm.R.merge(vm.$route, { query: { id: vm.privateID } }))
          vm.$q.notify({
            message: 'Đã lưu thành công',
            color: 'black',
            icon: 'check'
          })
          if (vm.privateMode === 'CREATE' || vm.privateMode === 'COPY') {
            // Fetch permission
            await vm.$query(['Users', vm.$store.state.user.email]).then(res => {
              vm.$store.dispatch('registerUserProfile', res)
            })
          }
          vm.privateMode = 'EDIT'
          if (this.fetchAfterSubmit) {
            vm.fetchData(this.queryPath)
            this.$emit('detail-page-fetched', this.data)
          }
        }).catch(error => {
          console.log('Detail page', error)
          vm.$q.notify({
            message: error.toString(),
            color: 'red',
            icon: 'error'
          })
        })
      } catch (error) {
        console.log(error)
        vm.$q.notify({
          message: error,
          color: 'red',
          icon: 'error'
        })
      }
      vm.isSubmiting = false
    },
    showLoading () {
      if (this.$root.$children[0].$refs['top-loadding-bar']) this.$root.$children[0].$refs['top-loadding-bar'].start()
    },
    hideLoading () {
      let vm = this
      vm.$nextTick(() => {
        if (vm.$root.$children[0].$refs['top-loadding-bar']) vm.$root.$children[0].$refs['top-loadding-bar'].stop()
      })
    }
  }
}
</script>
